<template>
  <div class="about">
    <div id="topBar">
      <div id="name">枚举管理</div>
    </div>
    <hr style="margin-top: 0px" />
    <div class="c_content">
      <div id="elInput">
        <el-input
          class="input-with-select"
          size="small"
          placeholder="输入关键字进行过滤"
          v-model="filterText"
        >
          <el-button slot="append" icon="el-icon-search" @click="treeFilter"></el-button>
        </el-input>
      </div>
      <el-tree
        class="filter-tree"
        :data="enumData"
        :props="defaultProps"
        node-key="id"
        highlight-current
        :expand-on-click-node="false"
        @node-click="treeNodeClick"
        :filter-node-method="filterNode"
        :default-expanded-keys="defaultExpandedKeys"
        @node-expand="handleNodeExpand"
        @node-collapse="handleNodeCollapse"
        ref="tree"
      ></el-tree>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filterText: "",
      enumData: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      parentId: "-1",
      nodeId: "",
      formLabelWidth: "120px",
      chooseTreeNode: {},
      defaultExpandedKeys: []
    };
  },
  props: {
    parentMsg: Object
  },
  watch: {
    parentMsg: {
      handler(newValue, oldValue) {
        this.getTemplateTree(newValue);
      },
      immediate: true
    }
  },
  mounted: function() {
    this.getTemplateTree(false);
  },
  methods: {
    getTemplateTree(data) {
      this.$axios
        .get(this.$idmConfig.treeUrl + "?key=enum&t=" + new Date().getTime())
        .then(response => {
          if (response.data.length <= 0) {
            this.$emit("treeInfo", {
              listenParentId: "-1",
              listenParentName: "暂无"
            });
          } else {
            // 展开至第一级
            this.defaultExpandedKeys.push(response.data[0].id);
            if (
              response.data[0].children !== null &&
              response.data[0].children.length > 0
            ) {
              // 展开至第二级
              for (var i = 0; i < response.data[0].children.length; i++) {
                this.defaultExpandedKeys.push(response.data[0].children[i].id);
              }
            }
            this.enumData = response.data;
            if (!data.refreshTreeFlag) {
              this.$emit("treeInfo", {
                listenParentId: response.data[0].id,
                listenParentName: response.data[0].label
              });
            }
          }
        })
        .catch(error => {
          console.log("error:" + error.toString());
        });
    },
    // 树节点展开
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false;
      this.defaultExpandedKeys.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.defaultExpandedKeys.push(data.id);
      }
      debugger
    },
    // 树节点关闭
    handleNodeCollapse(data) {
      // 删除当前关闭的节点
      this.defaultExpandedKeys.some((item, i) => {
        if (item === data.id) {
          this.defaultExpandedKeys.splice(i, 1);
        }
      });
    },
    treeNodeClick(node) {
      this.chooseTreeNode = node;
      this.$emit("treeInfo", {
        listenParentId: node.id,
        listenParentName: node.label
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    treeFilter() {
      this.$refs.tree.filter(this.filterText);
    }
  }
};
</script>

<style scoped lang="less">
.about {
  padding: 10px 0;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-flow: column nowrap;
  .c_content{
    flex: 1;
    height: calc(100% - 32px);
  }
}

#topBar {
  margin-top: 5px;
}

#name {
  float: left;
  color: black;
  font-size: 18px;
  font-weight: bold;
  margin-left: 15px;
}

#btnAdd {
  float: right;
  margin-right: 15px;
}

#cContent {
  height: 568px;
  padding: 0px;
  margin: 0px;
}
#elInput {
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.filter-tree{
    height: calc(100% - 42px);
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnumTree.vue